import { render, staticRenderFns } from "./send.vue?vue&type=template&id=31d1d46d&"
import script from "./send.vue?vue&type=script&lang=ts&"
export * from "./send.vue?vue&type=script&lang=ts&"
import style0 from "./send.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports